import { INotification } from './slice/types';
import { useDispatch } from 'react-redux';
import { useNotificationsSlice } from './slice';

export default function useNotificantionProvider() {
    const dispatch = useDispatch();
    const { actions } = useNotificationsSlice();
    const setNotification = (props: INotification) => {
        dispatch(actions.setNotification(props));
    };

    return { setNotification };
}
